import autoUploadOnboarding from 'img/quota-landing/autoupload-onboading.png';
import autoUploadOnboardingD from 'img/quota-landing/autoupload-onboading-1.png';
import autoUploadOnboardingMobile from 'img/quota-landing/autoupload-onboading-mobile.png';
import autoUploadOnboardingDMobileD from 'img/quota-landing/autoupload-onboading-mobile-1.png';

export type AutoUploadOnboardingData = {
    title: string;
    text: string;
    img: string;
    buttonText: string;
};

type AutoUploadOnboardingVariant = 'b' | 'c' | 'd';

export const autoUploadOnboardingGaName: Record<AutoUploadOnboardingVariant, string> = {
    b: 'mnz_autoload_chose_tarif',
    c: 'mnz_autoload_1tb',
    d: 'mnz_autoload_1tb_v2_p1',
};

export const autoUploadOnboardingData: Record<AutoUploadOnboardingVariant, AutoUploadOnboardingData> = {
    b: {
        title: 'Фото и видео не тратят память телефона\u00A0—\u00A0это\u00A0реально?',
        text: 'Да! С безлимитной автозагрузкой фото и видео с\u00A0телефона загрузятся в Облако, но место не займут',
        img: autoUploadOnboarding,
        buttonText: 'Выбрать тариф Mail Space',
    },
    c: {
        title: 'Фото и видео не тратят память телефона\u00A0—\u00A0это\u00A0реально?',
        text: 'Да! С безлимитной автозагрузкой фото и видео с\u00A0телефона загрузятся в Облако, но место не займут',
        img: autoUploadOnboarding,
        buttonText: 'Попробовать',
    },
    d: {
        title: 'Бесконечная память для телефона — так\u00A0бывает?',
        text: 'Бывает! Вы переносите фото и видео с телефона в\u00A0Облако, но они не занимают в нём место. Магия?!',
        img: autoUploadOnboardingD,
        buttonText: 'Расскажите же дальше',
    },
};

const mobileTitle = 'Бесконечная память для телефона\u00A0—\u00A0так бывает?';

export const autoUploadOnboardingMobileData: Record<AutoUploadOnboardingVariant, AutoUploadOnboardingData> = {
    b: {
        title: mobileTitle,
        text: 'Да! С безлимитной автозагрузкой галерея из\u00A0телефона загрузится в Облако, а место не\u00A0займёт. Совсем',
        img: autoUploadOnboardingMobile,
        buttonText: 'К выбору тарифов',
    },
    c: {
        title: mobileTitle,
        text: 'Да! С безлимитной автозагрузкой галерея из\u00A0телефона загрузится в Облако, а место не\u00A0займёт. Совсем',
        img: autoUploadOnboardingMobile,
        buttonText: 'Попробовать',
    },
    d: {
        title: mobileTitle,
        text: 'Бывает! Вы переносите фото и видео с\u00A0телефона  в Облако, но они не занимают в\u00A0нём место. Магия?!',
        img: autoUploadOnboardingDMobileD,
        buttonText: 'Расскажите же дальше',
    },
};
